import { createElement, } from 'react';
import { snakeToPascal, } from 'common/functions';
import SvgIcon, { SvgIconProps, } from 'common/components/SvgIcon';

// @ts-ignore
const reqSvgs = require.context('assets/icons', true, /icon_[a-z0-9_]+.svg$/);

type Images = {
    [key: string]: any,
};

const svgIcons = reqSvgs
    .keys()
    .reduce((images: Images, path: any) => {
        const [ , name, ] = path.match(/icon_([a-z0-9_]+).svg$/);
        const createComponent = (props: Omit<SvgIconProps, 'src'>) => createElement(SvgIcon, { src: reqSvgs(path), ...props,});

        return {
            ...images,
            [snakeToPascal(name)]: createComponent,
        };
    }, {});

export default svgIcons;
